import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubPulsarsDiscoveryHeroHeaderCustomCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Pulsars Discovery Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryHeroHeaderCustomCls || '', 'he_hub_pulsars_discovery_hero', { animCls: 'animate__zoomIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;